export default __webpack_public_path__ + "b2413bf5dbc6b16d549ca08dfc526876.jpeg";